
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getServiceList } from '@/api/service';

import DeptDialog from '@/components/DeptDialog/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';
@Component({
  name: 'orderSearch',
  components: {
    DeptDialog,
    FaultDialog
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private servicerOptions = [];
  private params: object = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
  }
  private taskStatusOptions = [
    // { value: '1', label: '待寄出' }
  // { value: '2', label: '已寄出' },
  // { value: '3', label: '已收货' },
  // { value: '4', label: '已寄回' }
    { value: '29', label: '未完成' },
    { value: '24', label: '已完成' },
    { value: '1', label: '待寄出' }
  ];
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private deptTypeCustomer = 1
  private departmentVisible = false
  private faultVisible= false

  private servicerFocus() {
    getServiceList(this.params).then(res => {
      if (res && res.data) {
        this.servicerOptions = res.data.list;
      }
    });
  }

  private selectedDeptCustomer() {
    this.departmentVisible = true;
  }
  private departmentClose(value: any) {
    this.departmentVisible = value;
  }
  private departmentSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.dept_id;
    this.changeData();
  }

  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private faultSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
